import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "src/pages/_partials/Layout";
import NavBar2 from 'src/componets/NavBar2';
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Bundles',
      icon: 'fa-brands fa-app-store-ios',
      url: callrecorderUrls.bundlesPath({ order_by: 'prod_env' })
    },
    5: {
      id: 5,
      name: 'Providers',
      icon: 'fa-solid fa-tower-cell',
      url: callrecorderUrls.providersPath()
    },
    4: {
      id: 4,
      name: 'Phone Numbers',
      icon: 'fa-solid fa-phone',
      subcategories: [7, 8, 2, 3, 11]
    },

    // subcategories — Phone Numbers
    2: {
      id: 2,
      name: 'Subscription Plans',
      url: callrecorderUrls.phnSubscriptionPlansPath()
    },
    3: {
      id: 3,
      name: 'SMS Packages',
      url: callrecorderUrls.smsPackagesPath()
    },
    6: {
      id: 6,
      name: 'Imports',
      icon: 'fa-solid fa-file-csv',
      url: callrecorderUrls.csvImportsPath()
    },
    13: {
      id: 13,
      name: 'Rates',
      icon: 'fa-solid fa-file-invoice-dollar',
      url: callrecorderUrls.ratesPath()
    },
    7: {
      id: 7,
      name: 'Available Numbers',
      url: callrecorderUrls.availablePhoneNumbersPath({ address_required: 'false' })
    },
    8: {
      id: 8,
      name: 'Number Prices',
      url: callrecorderUrls.phoneNumberPricesPath()
    },
    11: {
      id: 11,
      name: 'UN Subscriptions',
      url: callrecorderUrls.userNumberSubscriptionsPath()
    },
    9: {
      id: 9,
      name: 'Users',
      icon: 'fa-solid fa-users',
      url: callrecorderUrls.usersPath()
    },
    10: {
      id: 10,
      name: 'CDRs',
      icon: 'fa-solid fa-phone-volume',
      url: callrecorderUrls.cdrsPath()
    },
    14: {
      id: 14,
      name: 'Refunds',
      icon: 'fa-solid fa-rotate-left',
      url: callrecorderUrls.refundsPath({ order_by: 'refunded_at', order: 'desc' })
    }
  };

  const PARENT_PAGE_IDS = [1, 5, 13, 9, 10, 14, 6, 4];
  const PAGE_IDS = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => {
    if (!PAGES[id].url) return false;
    const pagePath = PAGES[id].url.split('?')[0];
    return pathname.startsWith(pagePath);
  });

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PARENT_PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
